import React, { useState, useEffect } from "react";
import "antd/dist/antd.css";
import "../../css/profile.css";
import DifferentlyAbled from "../../components/DifferentlyAbled";
import HeaderText from "../../components/HeaderText";
import SubHeaderText from "../../components/SubText";
import SelectSection from "../../components/SelectSection";
import PlacesLocation from "../../components/PlacesLocation";
import GenericInputField from "../../components/GenericInputField";
import GenericButton from "../../components/GenericButton";
import CompleteProfileInfoArea from "../../components/CompleteProfileInfoArea";
import Navbar from "../../components/Navbar";
import { isEmpty, isNil } from "lodash";
import GenericTextArea from "../../components/GenericTextArea";
import { useAppDispatch, useAppSelector } from "../../store/store";
import { useNavigate } from "react-router-dom";
import { useUpdateProfileMutation } from "../../store/appSlice";
import { PROFILE_COMPLETION_FOCUS_TABS } from "../../constants/stringConstants";
import ProfileCompletionMap from "./ProfileCompletionMap";
import { GenderType, LatLngType } from "../../interfaces/commons";
import ImageUploader from "../../components/ImageUploader";
import ProfileCompletionCandidateExperience from "../../components/profileCompletion/Experience/ProfileCompletionCandidateExperience";
import ProfileCompletionCandidateEducation from "../../components/profileCompletion/Education/ProfileCompletionCandidateEducation";
import {
  useGetEducationsMutation,
  useGetProfileDataFromDBMutation,
} from "../../store/profileSlice";
import { setEducations, setProfileData } from "../../reducers/userReducer";
import { UserProfileCompletion } from "../../interfaces/user";
import VideoRecorderComponent from "../../components/VideoRecorderComponent";

const Gender = [
  { id: 1, text: "Male" },
  { id: 2, text: "Female" },
  { id: 3, text: "Others" },
];

function ProfileCompletion() {
  const { user } = useAppSelector((state) => state["user"]);

  console.log({ user });
  const [latLng, setLatLng] = useState<LatLngType>({ lat: 0, lng: 0 });
  const [locationAddress, setLocationAddress] = useState<string>();
  const [selectedGender, setSelectedGender] = useState<GenderType>();
  const [isChangeDifferentlyAbled, setChangeDifferentlyAbled] =
    useState<boolean>(false);
  const [videoUrl, setVideoUrl] = useState<string>("");
  const [imageFile, setImageFile] = useState<string>("");
  const [userData, setUserData] = useState<UserProfileCompletion | null>(null);
  const [isFreshCandidate, setIsFreshCandidate] = useState(false);

  const [input, setInput] = useState({
    zipCode: "",
    profileAboutMe: "",
    profileTitle: "",
  });

  const [error, setError] = useState({
    gender: "",
    zipCode: "",
    profileAboutMe: "",
    profileTitle: "",
    education: "",
    experience: "",
    location: "",
  });

  const navigate = useNavigate();
  const { allEducations } = useAppSelector((state) => state["user"]);
  const [getEducations] = useGetEducationsMutation();
  const dispatch = useAppDispatch();

  const [updateProfile] = useUpdateProfileMutation();
  const [getProfileDataFromDB] = useGetProfileDataFromDBMutation();

  useEffect(() => {
    getProfileDetailsFromDb();
    getAllDegrees();
  }, []);

  useEffect(() => {
    console.log({ userData });
  }, [userData]);

  const getProfileDetailsFromDb = async () => {
    const filterDetails = encodeURIComponent(`
    
{
    "fields": {
        "id": true,
        "title": true,
        "profilePicture": true,
        "town": true,
        "aboutYou": true,
        "video": true,
        "yearsOfExperience": true,
        "industryIds": true,
        "professionIds": true,
        "skillIds": true,
        "userId": true,
        "country": true,
        "city": true,
        "location":true
    },
    
    "include": [{
            "relation": "candidateWorkExperiences"
            
        },
        {
            "relation": "candidateEducations"
        },
        {
            "relation": "candidateCertificates"
        },
        {
            "relation": "candidatePortfolios"
              
        },
        {
            "relation": "candidateJobCriteria"
              
        },
        {
            "relation": "user"
        }
    ]
}
`);

    let payload = {
      filterDetails,
      param: user?.id ?? "",
    };
    console.log({ payload });
    getProfileDataFromDB(payload)
      .unwrap()
      .then((incomingData) => {
        console.log({ incomingDataProfile: incomingData });
        setUserData(incomingData);
        dispatch(setProfileData(incomingData));
      })
      .catch((err) => {
        console.log("error");

        console.log(err);
      });
  };

  useEffect(() => {
    console.log({ allEducations });
  }, [allEducations]);

  const onSelectGender = (selected: GenderType) => {
    console.log(selected);
    setSelectedGender(selected);
  };

  const onChangeDifferentlyAbledType = () => {
    setChangeDifferentlyAbled(!isChangeDifferentlyAbled);
  };

  const onTextInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInput({ ...input, [e.target.name]: e.target.value });
  };

  const onTextAreaChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setInput({ ...input, [e.target.name]: e.target.value });
  };

  const asterikSign = () => (
    <h2
      style={{
        color: "red",
        fontSize: "20px",
        marginLeft: "10px",
        marginBottom: 10,
      }}
    >
      {" "}
      *
    </h2>
  );

  const validation = () => {
    let valid = true;
    let gender = "";
    let zipCode = "";
    let profileTitle = "";
    let profileAboutMe = "";
    let education = "";
    let experience = "";
    let location = "";

    if (isEmpty(selectedGender)) {
      gender = "Select a gender";
      valid = false;
    }

    if (isEmpty(locationAddress)) {
      location = "Location address cannot be empty";
      valid = false;
    }

    if (!isEmpty(locationAddress) && latLng.lat === 0) {
      location = "Select location from the list";
      valid = false;
    }

    if (isEmpty(input.zipCode)) {
      zipCode = "Zipcode cannot be empty";
      valid = false;
    }
    if (isEmpty(input.profileTitle)) {
      profileTitle = "Profession cannot be empty";
      valid = false;
    }
    if (isEmpty(input.profileAboutMe)) {
      profileAboutMe = "About me cannot be empty";
      valid = false;
    }

    if (
      isNil(userData?.candidate?.candidateEducations) ||
      isEmpty(userData?.candidate?.candidateEducations)
    ) {
      education = "Education cannot be empty";
      valid = false;
    }

    if (
      (isNil(userData?.candidate?.candidateWorkExperiences) ||
        isEmpty(userData?.candidate?.candidateWorkExperiences)) &&
      !isFreshCandidate
    ) {
      experience = "Experience cannot be empty";
      valid = false;
    }

    setError({
      ...error,
      gender,
      zipCode,
      profileTitle,
      profileAboutMe,
      experience,
      education,
      location,
    });

    return valid;
  };

  const onContinue = (e: React.MouseEvent<HTMLElement>) => {
    if (validation()) {
      let data = {
        gender: selectedGender?.text,
        disability: isChangeDifferentlyAbled,
        zipCode: input.zipCode,
        aboutYou: input.profileAboutMe,
        title: input.profileTitle,
        location: latLng,
        profilePicture: imageFile,
        video: videoUrl,
      };
      const payload = {
        ...data,
        param: user?.id,
      };

      updateProfile(payload)
        .unwrap()
        .then((incomingData) => {
          console.log({ incomingData });
          navigate("/profile/desired_job");
        })
        .catch((err) => {});
    }
  };

  const errorSec = (err: string) => (
    <div style={{ marginTop: "10px" }}>
      <text style={{ color: "red", fontWeight: "600" }}>{err}</text>
    </div>
  );

  const getAllDegrees = () => {
    getEducations({})
      .unwrap()
      .then((incomingData) => {
        dispatch(setEducations(incomingData));
      })
      .catch((err) => {
        console.log("error");
        console.log(err);
      });
  };

  const getLatLngAndAddress = (latLng: LatLngType, address: string) => {
    console.log(latLng);
    setLatLng(latLng);
    setLocationAddress(address);
  };

  const onLocationTextChange = (e: any) => {
    console.log(e.target.value);
    setLocationAddress(e.target.value);
  };

  return (
    <div className="profile__container">
      <Navbar />
      <div style={{ marginTop: 70 }} />
      <CompleteProfileInfoArea
        focusTab={PROFILE_COMPLETION_FOCUS_TABS.TARGET}
      />

      {/* 1st screen */}
      <div
        style={{
          flexDirection: "row",
          display: "flex",
          width: "100%",
        }}
      >
        <div className="profile_sec_container">
          <div className="who_are_you_container">
            <div
              className="header_text_screen2"
              style={{ flexDirection: "row" }}
            >
              <HeaderText text={"Please select gender"} />
              {asterikSign()}
            </div>
            <div className="gender_options_sec">
              {Gender.map((item) => {
                return (
                  <SelectSection
                    key={item.id}
                    text={item.text}
                    item={item}
                    isActive={selectedGender?.id === item.id}
                    setIsActive={(selected: GenderType) =>
                      onSelectGender(selected)
                    }
                  />
                );
              })}
              {!isEmpty(error.gender) && errorSec(error.gender)}
            </div>
            <DifferentlyAbled
              onToggleChange={() => onChangeDifferentlyAbledType()}
              isDisabled={isChangeDifferentlyAbled}
            />
          </div>
          <div className="border_bottom_signup_process_heading"></div>

          {/* 2nd screen */}

          <div style={{ marginLeft: 20, marginBottom: 10, marginTop: 16 }}>
            <HeaderText text={"Are you a fresh graduate?"} />
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 10,
                marginTop: 20,
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <input
                  type="radio"
                  onChange={() => {
                    setIsFreshCandidate(true);
                  }}
                  style={{
                    width: "18px",
                    height: "18px",
                    marginLeft: "5px",
                    marginRight: "12px",
                  }}
                  checked={isFreshCandidate}
                />
                <text
                  style={{
                    fontSize: "15px",
                    marginTop: "-2px",
                    color: "grey",
                    fontWeight: "bold",
                  }}
                >
                  YES
                </text>
              </div>

              <div style={{ display: "flex", alignItems: "center" }}>
                <input
                  type="radio"
                  onChange={() => {
                    setIsFreshCandidate(false);
                  }}
                  style={{
                    width: "18px",
                    height: "18px",
                    marginLeft: "5px",
                    marginRight: "12px",
                  }}
                  checked={!isFreshCandidate}
                />
                <text
                  style={{
                    fontSize: "15px",
                    marginTop: "-2px",
                    color: "grey",
                    fontWeight: "bold",
                  }}
                >
                  NO
                </text>
              </div>
            </div>
          </div>
          <div className="border_bottom_signup_process_heading"></div>

          <div className="where_you_live_container">
            <div className="header_text_screen2">
              <HeaderText text={"Where do you live?"} />
              <SubHeaderText
                text={
                  "Your address details enable us to match your profile with relevant jobs in your vicinity."
                }
              />
            </div>

            <div style={{ marginBottom: "50px" }}>
              <div
                style={{
                  flexDirection: "row",
                  display: "flex",
                  alignItems: "center",
                  marginBottom: 8,
                }}
              >
                <p
                  style={{ marginBottom: "1rem" }}
                  className="complete_profile_input_fields_heading"
                >
                  Location
                </p>
                {asterikSign()}
              </div>

              <PlacesLocation
                getLocationLatLngAndAddress={getLatLngAndAddress}
                locationAddress={locationAddress}
                onLocationTextChange={onLocationTextChange}
                setLatLng={setLatLng}
                hasError={!isEmpty(error.location)}
              />
              <div style={{ marginTop: 45 }}>
                {!isEmpty(error.location) && errorSec(error.location)}
              </div>
            </div>

            <div style={{ marginBottom: "5px" }}>
              <div
                style={{
                  flexDirection: "row",
                  display: "flex",
                  alignItems: "center",
                  // marginBottom: 8,
                  marginBottom: -7,
                }}
              >
                <p
                  style={{ marginBottom: "1rem" }}
                  className="complete_profile_input_fields_heading"
                >
                  Zip Code
                </p>
                {asterikSign()}
              </div>
              <GenericInputField
                handleOnChange={onTextInputChange}
                name="zipCode"
                text={input.zipCode}
                error={!isEmpty(error.zipCode)}
              />
              {!isEmpty(error.zipCode) && errorSec(error.zipCode)}
            </div>
          </div>
          <div className="border_bottom_signup_process_heading"></div>

          {/* image start */}
          <div className="job_type_container">
            <div className="header_text_screen2">
              <HeaderText text={"Please provide your details"} />
            </div>

            <ImageUploader getImageFile={setImageFile} />

            <div
              style={{ marginBottom: "2rem", marginTop: "4rem" }}
              className="complete_profile_input_fields_heading"
            >
              <div
                style={{
                  flexDirection: "row",
                  display: "flex",
                  alignItems: "center",
                  marginBottom: 6,
                }}
              >
                <p
                  style={{ marginBottom: "1rem" }}
                  className="complete_profile_input_fields_heading"
                >
                  Profession
                </p>
                {asterikSign()}
              </div>

              <GenericInputField
                handleOnChange={onTextInputChange}
                text={input.profileTitle}
                name="profileTitle"
                error={!isEmpty(error.profileTitle)}
              />
              {!isEmpty(error.profileTitle) && errorSec(error.profileTitle)}
            </div>
            <div
              style={{ marginBottom: "2rem", marginTop: "1.5rem" }}
              className="complete_profile_input_fields_heading"
            >
              <div
                style={{
                  flexDirection: "row",
                  display: "flex",
                  alignItems: "center",
                  marginBottom: 6,
                }}
              >
                <p
                  style={{ marginBottom: "1rem" }}
                  className="complete_profile_input_fields_heading"
                >
                  About me
                </p>
                {asterikSign()}
              </div>

              <GenericTextArea
                handleOnChange={onTextAreaChange}
                text={input.profileAboutMe}
                name="profileAboutMe"
                error={!isEmpty(error.profileAboutMe)}
              />
              {!isEmpty(error.profileAboutMe) && errorSec(error.profileAboutMe)}
            </div>
          </div>
          <div className="border_bottom_signup_process_heading"></div>

          <div style={{ paddingTop: 20, paddingBottom: 15 }}>
            <h4 style={{ marginLeft: 20 }}>Introductory Video</h4>
            <div style={{ marginLeft: 20, marginBottom: 10 }}>
              <SubHeaderText
                text={
                  "Boost your hiring chances,upload a quick 25-30s intro video. It makes a difference!"
                }
              />
            </div>
            <div style={{ marginRight: "17%" }}>
              <VideoRecorderComponent
                onSelectVideo={(url: string) => {
                  setVideoUrl(url);
                }}
                fromProfile={true}
                isEdit={true}
                incomingVideoUrl={userData?.candidate?.video ?? null}
              />
            </div>
          </div>
          <div className="border_bottom_signup_process_heading"></div>

          <ProfileCompletionCandidateExperience
            getUpdatedData={getProfileDetailsFromDb}
            data={userData?.candidate?.candidateWorkExperiences ?? []}
            asterikSign={!isFreshCandidate ? asterikSign : () => {}}
            errorSec={errorSec}
            error={error.experience}
          />

          <div className="border_bottom_signup_process_heading"></div>

          <ProfileCompletionCandidateEducation
            getUpdatedData={getProfileDetailsFromDb}
            data={userData?.candidate?.candidateEducations ?? []}
            asterikSign={asterikSign}
            errorSec={errorSec}
            error={error.education}
          />

          <div className="continue_btn_container">
            <GenericButton onBtnClick={onContinue} />
          </div>
        </div>

        <div className="showView">
          <ProfileCompletionMap
            selectedGender={selectedGender}
            isChangeDifferentlyAbled={isChangeDifferentlyAbled}
            locationAddress={locationAddress}
            zipCode={input.zipCode}
            profileTitle={input.profileTitle}
            profileAboutMe={input.profileAboutMe}
          />
        </div>
      </div>
    </div>
  );
}

export default ProfileCompletion;
